export const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250" preserveAspectRatio="xMidYMid meet">
  <g fill="{{HEADER_LINKS_COLOR}}" transform="translate(-72, -75)">
    <path d="M110 80 h210 v240 h-210 v-40 h18 v22 h174 v-204 h-174 v22 h-18 z" />
    <text
      x="75"
      y="250"
      font-family="Inter, system-ui, sans-serif"
      font-size="140"
      font-weight="700"
      letter-spacing="-5"
      fill="{{HEADER_LINKS_COLOR}}"
    >{{LOGO_INITIAL_1}}{{LOGO_INITIAL_2}}</text>
  </g>
</svg>
`;
